import Link from 'next/link'
import { Container } from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion'
import { Jobs } from 'src/@shared/types/cms/jobs'
import Button from 'react-bootstrap/Button'
import { scrollToTargetAdjusted } from 'src/@shared/functions/animations'

import FramerMotion from '@atk/hooks/framerMotion'

import styles from './JobAccordion.module.scss'

export type JobAccordionDefaultProps = {
    customClass?: string
    items: Jobs[]
}

export default function JobAccordion({ customClass, items }: JobAccordionDefaultProps) {
    const componentClass = `JobAccordion ${styles.JobAccordion} ${customClass ?? ''}`
    const itemClass = `${styles.itemContainer}`
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleOnSelect = (eventKey: any) => {
        if (eventKey) {
            setTimeout(() => {
                console.log(eventKey)
                scrollToTargetAdjusted(eventKey, 200)
            }, 250)
        }
        console.log('eventKey', eventKey, 'event', event)
    }
    return (
        <section className={componentClass}>
            <Container>
                <Accordion onSelect={handleOnSelect}>
                    {items.map((item: Jobs) => (
                        <FramerMotion key={item._id}>
                            <Accordion.Item className="mb-3" key={item._id} eventKey={item._id} id={item._id}>
                                <Accordion.Header>
                                    <div className={itemClass}>
                                        <p className="h5 mb-0">{item.title}</p> <p className="mb-0">{item.location}</p>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div
                                        className="jobBody"
                                        dangerouslySetInnerHTML={{ __html: item.body ?? '' }}
                                    ></div>
                                    {item.externalLink && (
                                        <Link href={item.externalLink} target="_blank" rel="noopener noreferrer">
                                            <Button variant="outline" className="btnBlogVertical">
                                                Apply Now
                                            </Button>
                                        </Link>
                                    )}
                                    <br />
                                    {/*                                 <Link
                                    className="permalink"
                                    title="Open a permalink to this Posting"
                                    href={`/careers/${item.meta.slug}`}
                                >
                                    Link
                                </Link> */}
                                </Accordion.Body>
                            </Accordion.Item>
                        </FramerMotion>
                    ))}
                </Accordion>
            </Container>
        </section>
    )
}
